import { slugify, uniquify } from '@/lib/slug';

import { MAX_SLUG_LENGTH } from './validation';

/** Used when `name` has no character a slug can be built from (e.g. all-punctuation or non-Latin). */
const FALLBACK_BASE = 'profile';

/**
 * Derives a profile slug from `name` for a person who never sees or types one.
 *
 * Mirrors the service's rules in `validation.ts` (`SLUG_PATTERN`, `MAX_SLUG_LENGTH`)
 * so the generated value is always accepted by the still-unchanged backend
 * contract. Deterministic and side-effect free: the same `name` and
 * `existingSlugs` always produce the same result.
 *
 * Never returns a value already in `existingSlugs` — on collision, appends the
 * smallest `-2`, `-3`, … suffix that makes the result unique, re-truncating so
 * the suffixed value still respects `MAX_SLUG_LENGTH`.
 */
export function generateProfileSlug(
  name: string,
  existingSlugs: string[],
): string {
  return uniquify(slugify(name, FALLBACK_BASE), existingSlugs, MAX_SLUG_LENGTH);
}
